import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rubro_id: null,
            pais_id: null,
            clasificacion_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    setSelects(data) {
        this.setState({
            rubro_id: data.rubro_id,
            pais_id: data.pais_id,
            clasificacion_id: data.clasificacion_id
        });
        
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.clientes.empresas.edit}
                postUrl={api.clientes.empresas.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Empresa ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Empresa"}
                buttonTitle={"Editar Empresa"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-4 col-md-3">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Razón Social</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="razonSocial"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>CUIT</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="cuit"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Clasificación</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"clasificacion_id"} url={api.clientes.clasificacion.select} value={this.state.clasificacion_id} onChange={(e) => this.setState({ clasificacion_id: (e != null ? e.pk : 0) })} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Rubro</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"rubro_id"} url={api.clientes.rubros.select} value={this.state.rubro_id} onChange={(e) => this.setState({ rubro_id: (e != null ? e.pk : 0) })} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4 col-md-3">
                        <Label>País</Label>
                    </Col>
                    <Col className="col-8 col-md-9">
                        <ParadigmaAsyncSeeker fieldName={"pais_id"} url={api.misc.paises.select} value={this.state.pais_id} onChange={(e) => this.setState({ pais_id: (e != null ? e.pk : 0) })} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Edit.js